import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ─── PWA · Service Worker registration ──────────────────────────────
// Powers offline photo capture + Background Sync for the Field Mode
// queue at the FWA Expo / low-signal properties. See
// /public/service-worker.js for the drain logic (sync tag:
// "drain-field-queue"). Registration is a no-op in dev builds where
// the worker file isn't served — we guard with a supports check.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.info("[pwa] service worker registered:", reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[pwa] service worker registration failed:", err);
      });
  });
}
